export default __webpack_public_path__ + "static/media/tiktok.797444d6.png";